// extracted by mini-css-extract-plugin
module.exports = {"red":"Widget-module__red___5yYlp","nrcstat__rootwidget":"Widget-module__nrcstat__rootwidget___pXtBD"};